import sha256 from 'fast-sha256';
import toBuffer from 'typedarray-to-buffer';

import * as bs58check from 'bs58check';

import { range } from '.';

const te = require('text-encoding-utf-8/src/encoding.js');

export function Id(uniformRand: () => number = Math.random) {
  const randHex = () => '0123456789abcdef'[Math.floor(16 * uniformRand())];
  return bs58check.encode(Buffer.from(range(16).map(randHex).join(''), 'hex'));
}

const utf8Encoder = te.TextEncoder('utf-8');

export default function hash(obj: {}): string {
  const objStr = JSON.stringify(obj);
  const encoded = utf8Encoder.encode(objStr);
  const hashed = sha256(encoded);
  const reencoded = bs58check.encode(toBuffer(hashed.slice(0, 128)));
  return reencoded;
}



// WEBPACK FOOTER //
// ./src/util/hash.ts